import React from 'react';

import ReportPage from '../../common/ReportPage';

import { fetchGetOrdersReportById } from '../../../actions/orders';

const ExportReportPage = (props) => {
  return <ReportPage {...props} getAction={fetchGetOrdersReportById} />;
};

export default ExportReportPage;
